module.exports = __webpack_public_path__ + "img/Fahrerseite_1T_C_Frontmotor.4ff7a67d.jpg";